import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const juhu: AreaConfig = {
  name: 'Juhu & Versova',
  slug: 'juhu',
  tagline: 'Doorstep iPhone & Mobile Repair in Juhu & Versova',
  description: 'Premium mobile repair at your doorstep in Juhu, Versova, and surrounding areas. No need to visit a service center — our certified technicians bring OEM-quality parts to your home. 6-month warranty on all battery replacements.',
  localities: [
    'Juhu', 'Juhu Beach', 'JVPD Scheme', 'Versova', 'Andheri West',
    'Seven Bungalows', 'Four Bungalows', 'Gulmohar Road', 'Irla',
    'Vile Parle West', 'Juhu Tara Road', 'NS Road Juhu',
  ],
  zones: [
    {
      name: 'Juhu & JVPD',
      line: 'Western Line',
      station: 'Vile Parle / Andheri Station',
      localities: ['Juhu', 'Juhu Beach', 'JVPD Scheme', 'Juhu Tara Road', 'Gulmohar Road', 'NS Road', 'Irla', 'Vile Parle West'],
      desc: 'Serving the affluent Juhu and JVPD residential belt. From beachside bungalows to luxury apartments — our technician arrives within 30 minutes.',
    },
    {
      name: 'Versova & Seven Bungalows',
      line: 'Western Line',
      station: 'Andheri Station / Versova Metro',
      localities: ['Versova', 'Seven Bungalows', 'Four Bungalows', 'Yari Road', 'JP Road', 'Madh Island access'],
      desc: 'Covering the premium Versova and Seven Bungalows area. Popular among media professionals and creators who need quick phone repairs without disrupting their schedule.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Juhu & Versova | Doorstep iPhone Repair | minto',
    description: 'Premium doorstep iPhone & mobile repair in Juhu, Versova, JVPD Scheme. OEM battery replacement, screen repair. 6-month warranty, no Unknown Part warning. 30-minute service at your home.',
    keywords: 'mobile repair Juhu, iPhone repair Juhu, phone repair Versova, battery replacement Juhu, screen repair JVPD, doorstep mobile repair Juhu, iPhone repair Seven Bungalows, phone repair Vile Parle West, premium mobile repair Juhu Beach',
  },
  faqs: [
    {
      q: 'Do you provide doorstep repair in Juhu and JVPD area?',
      a: 'Yes, we cover all of Juhu including JVPD Scheme, Gulmohar Road, Juhu Tara Road, and surrounding areas. Technician arrives within 30-45 minutes.',
    },
    {
      q: 'Can you repair my iPhone at home in Versova?',
      a: 'Absolutely. We regularly visit homes in Versova and Seven Bungalows for iPhone battery replacements and screen repairs. Everything is done at your doorstep.',
    },
    {
      q: 'What brands do you repair in Juhu?',
      a: 'We repair all brands including Apple iPhone, Samsung Galaxy, OnePlus, Google Pixel, and more. iPhone repairs are our specialty with OEM-quality parts.',
    },
    {
      q: 'Is it safe to get my iPhone repaired at home?',
      a: 'Yes! Our technicians are ID-verified, background-checked professionals. They repair your phone right in front of you — your device never leaves your sight.',
    },
  ],
};

const JuhuPage: React.FC = () => <AreaLandingPage area={juhu} />;
export default JuhuPage;
